import { MealInfo } from '@/src/types/itinerary'
import Meal from './meal'

const MealWrapper = ({
    mealOptions,
    paxCount,
    selectedMealOptions,
    handleAddMeal,
    handleRemoveMeal,
    formatCurrency
}: {
    mealOptions: MealInfo[]
    paxCount: number
    selectedMealOptions: Partial<MealInfo>[]
    handleAddMeal: (meal: MealInfo) => void
    handleRemoveMeal: (meal: MealInfo) => void
    formatCurrency: (price: number) => string
}) => {
    return (
        <Meal
            mealOptions={mealOptions}
            paxCount={paxCount}
            selectedMealOptions={selectedMealOptions}
            handleAddMeal={handleAddMeal}
            handleRemoveMeal={handleRemoveMeal}
            formatCurrency={formatCurrency}
        />
    )
}

export default MealWrapper
